import React from 'react';
import '../App.css';
import TUDublinLogo from './tu-dublin-logo.svg';
import {EMAIL} from '../utils/Constants.js';
function Footer(){


  return(
    <div className="footer">
      <div className="footer-left center">
        <p>&#169;2021 ODE</p>
      </div>
      <div className="footer-center center">
        <img src={TUDublinLogo} alt="TU Dublin"/ >
      </div>
      <div className="footer-right center">
        <p><a style={{color:"white", textDecorationLine: 'none'}} href={"mailto:"+EMAIL}>{EMAIL}</a></p>
      </div>
    </div>
  )
}

export default Footer
